import React from 'react'
import { HeartbeatComponent } from '#src/generated/graphql'

const Heartbeat: React.SFC = () => <HeartbeatComponent />

export default Heartbeat
